import { render, staticRenderFns } from "./cost-consulting.vue?vue&type=template&id=339407c9&scoped=true"
import script from "./cost-consulting.vue?vue&type=script&lang=js"
export * from "./cost-consulting.vue?vue&type=script&lang=js"
import style0 from "./cost-consulting.vue?vue&type=style&index=0&id=339407c9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339407c9",
  null
  
)

export default component.exports